import { useContext, useEffect } from 'react';

import { MessagingContext } from '@sorare/wallet-shared';
import type { Transaction } from '@sorare/wallet-shared';

import { useSnackNotificationContext } from '#src/contexts/snackNotification/index.ts';
import {
  WalletTab,
  useWalletDrawerContext,
} from '#src/contexts/walletDrawer/index.tsx';
import { txLink } from '#src/lib/etherscan.ts';

import { useUpdateExternalEthDeposit } from './useUpdateExternalEthDeposit.ts';

export const useTransaction = () => {
  const { setCurrentTab, hideWallet } = useWalletDrawerContext();
  const [updateExternalDeposit] = useUpdateExternalEthDeposit();
  const { registerHandler } = useContext(MessagingContext)!;
  const { showNotification } = useSnackNotificationContext();

  useEffect(
    () =>
      registerHandler<Transaction>(
        'transaction',
        async ({ hash, depositId }) => {
          setCurrentTab(WalletTab.HOME);
          hideWallet();
          if (hash && depositId) {
            await updateExternalDeposit({
              variables: {
                input: {
                  id: depositId,
                  transactionHash: hash,
                },
              },
            });
            showNotification('txSent', {}, { link: txLink(hash) });
          }
          return {};
        }
      ),
    [
      hideWallet,
      registerHandler,
      setCurrentTab,
      showNotification,
      updateExternalDeposit,
    ]
  );
};
